import { Children, ComponentType, ReactElement } from 'react';
import styled, { IStyledComponent } from 'styled-components';
import { FlexAlignCenter } from 'components/primitives/flex';
import { useAtom, WritableAtom } from 'jotai';

export interface CustomLabelComponentProps {
  children: string;
  active: boolean;
}

interface TabProps {
  label: string;
  name: string;
  children: string | ReactElement[] | ReactElement;
  labelProps?: any;
}

interface TabsProps {
  activeTabNameAtom: WritableAtom<string, string>;
  children: ReactElement<TabProps> | Array<ReactElement<TabProps>>;
  CustomLabelComponent: ComponentType<CustomLabelComponentProps> | IStyledComponent<any, any>;
  onTabChange?: (string) => void;
  disabled?: boolean;
}

export default function Tabs({ children, activeTabNameAtom, CustomLabelComponent, onTabChange, disabled }: TabsProps) {
  const [activeTabName, setActiveTabName] = useAtom(activeTabNameAtom);

  return (
    <div>
      {/* Labels */}
      <TabLabels>
        {Children.map(children, (child) =>
          child ? (
            <TabLabel
              onClick={
                !disabled
                  ? () => {
                      onTabChange?.(child.props.name);
                      setActiveTabName(child.props.name);
                    }
                  : null
              }
            >
              <CustomLabelComponent
                active={!disabled && activeTabName === child.props.name}
                {...child.props.labelProps}
              >
                {child.props.label}
              </CustomLabelComponent>
            </TabLabel>
          ) : null
        )}
      </TabLabels>

      {/* Contents */}
      {!disabled &&
        Children.map(children, (child) =>
          child ? <TabPanel>{activeTabName === child.props.name && child}</TabPanel> : null
        )}
    </div>
  );
}

export const Tab = ({ children }: TabProps) => children as ReactElement;

const TabLabels = styled(FlexAlignCenter)`
  /* TODO extract this styling if reused */
  border-top: solid 1px #dbdfe5;
  margin: 0 24px;
`;

const TabLabel = styled.div`
  flex: 1;
  cursor: pointer;
`;

const TabPanel = styled.div``;
